module.exports = __webpack_public_path__ + "static/img/j1.25d7189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/j1.png
// module id = 3/9A
// module chunks = 1